<template>
  <v-card flat>
    <v-card-text ref="columnChartDiv" id="columnChartDiv" class="py-0">
      <v-skeleton-loader
        v-if="!chartOptions || !updated_chart_data || updated_chart_data.length <= 1"
        type="image"
      ></v-skeleton-loader>
      <GChart
        v-else
        type="ColumnChart"
        :options="chartOptions"
        :data="updated_chart_data"
        :events="chartEvents"
        :debounce="500"
        @ready="onChartReady"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ColumnChartVT",
  props: {
    chartData: Array,
    width: String,
    height: String,
    xlabel: String,
    ylabel: String,
    hAxis: Object,
    colors: Array,
    dataOpacity: String,
    isStacked: { type: Boolean, default: true },
  },
  watch: {
    height: function (newVal) {
      this.chartOptions.height = newVal || 700;
    },
  },
  data: function () {
    return {
      chart: null,
      chartsLib: {},
      chartOptions: {
        backgroundColor: "transparent",
        width: this.width || "100%",
        chartArea: {
          width: "94%",
        },
        csv_headers: "1",
        responsive: true,
        maintainAspectRatio: false,
        height: this.height || 300,
        legend: {
          position: "bottom",
          maxLines: 2,
          textStyle: {
            color: this.$vuetify.theme.dark ? "#A9A9A9" : "#a1c7e2",
            fontSize: 9,
          },
        },
        dataOpacity: this.dataOpacity || 1,
        tooltip: { isHtml: true },
        colors: this.colors || ["#1b428b", "#e14615", "#52a0d1"],
        hAxis: this.hAxis || {
          title: this.xlabel,
          textStyle: {
            color: this.$vuetify.theme.dark ? "#A9A9A9" : "#a1c7e2",
            fontSize: 9,
          },
          viewWindowMode: "maximized",
        },
        vAxis: {
          title: this.ylabel,
          gridlines: { color: "#325597", count: 3 },
          minorGridlines: { color: "#fff" },
          textStyle: {
            color: this.$vuetify.theme.dark ? "#ffffff" : "#a1c7e2",
            fontSize: 9,
          },
          viewWindowMode: "maximized",
        },
        isStacked: this.isStacked,
        animation: {
          duration: 700,
          easing: "in",
          startup: true,
        },
      },
      chartEvents: {
        select: () => {
          let selection = this.chart.getSelection()[0];
          if (selection) {
            this.$emit("on-click", this.updated_chart_data[selection.row + 1][0]);
            this.$emit("on-click-inner-col", selection);
          } else {
            this.$emit("on-click", "");
            this.$emit("on-click-inner-col", "");
          }
        },
        error: (errorObj) => {
          if (errorObj.message == "Data column(s) for axis #0 cannot be of type string")
            window.$(`#${errorObj.id} span`)[0].innerHTML =
              "Oops, there is no data available for the selected time period.";
        },
      },
    };
  },
  methods: {
    onChartReady(chart) {
      this.chart = chart;
    },
    createCustomHTMLContent(title, msg, value) {
      return `<div class='d-flex rounded custom-tooltip'>
      <div class='pl-1 rounded-l primaryOutline'></div>
      <div class='d-flex flex-column primaryDark--text px-2'>
        <div>
          ${title}
        </div>
        <div class='primaryGrey--text caption'>
          <span class='primaryDark--text font-weight-bold'>
          ${value}
        </span>${msg}
        </div>
      </div>
    </div> `;
    },
  },
  created() {
    this.page_config = this.$config;
  },
  computed: {
    cardBackgroundColor() {
      return this.$vuetify.theme.dark
        ? this.$vuetify.theme.themes.dark.backgroundWhite
        : this.$vuetify.theme.themes.light.backgroundWhite;
    },
    msg() {
      return this.$auth.error;
    },
    updated_chart_data() {
      return this.chartData;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .custom-tooltip {
  width: 150px;
  min-height: 50px;
  max-height: 200px;
  border: none;
  box-shadow:
    -3px -1px 20px 0 rgba(0, 0, 0, 0.18),
    0 6px 20px 0 rgba(153, 155, 168, 0.1);
}
::v-deep .google-visualization-tooltip {
  border: none !important;
}
</style>
